import { createFileRoute } from '@tanstack/react-router';

import { createPageMetaTitle } from 'src/utils/createPageMetaTitle';

export const Route = createFileRoute('/_auth/_layout/myfiles')({
  staticData: { title: createPageMetaTitle('My files') },
});
